<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12 pl-0 fuente-titulo">
				<p>Configuraci&oacute;n de cuenta / Cambio de contrase&ntilde;a</p>
			</div>
		</div>
		<div class="row">
			<div class="col-12 col-lg-9 col-xl-8 fondo-cambio py-4">
				<p class="fuente-subtitulo">Cambio de contrase&ntilde;a</p>
				<p
					class="fuente-texto"
				>Recuerda que la nueva contrase&ntilde;a debe ser m&aacute;s de 4 caracteres, (sin puntos, comas y espacios) contener una may&uacute;scula, etc.</p>

				<div class="row">
					<div class="form-group col-12 col-lg-6">
						<label class="fuente-texto">Contrase&ntilde;a actual</label>
						<input
							:class="{ 'is-invalid': $v.passAnterior.$error }"
							class="form-control fuente-input"
							ref="passAnterior"
							tabindex="1"
							type="password"
							v-model="$v.passAnterior.$model"
						/>
					</div>
				</div>

				<div class="row">
					<div class="form-group col-12 col-lg-6">
						<label class="fuente-texto">Nueva contrase&ntilde;a</label>
						<input
							:class="{ 'is-invalid': $v.passNuevo1.$error }"
							class="form-control fuente-input"
							tabindex="2"
							type="password"
							v-model="$v.passNuevo1.$model"
						/>
					</div>
				</div>

				<div class="row mb-3">
					<div class="form-group col-12 col-lg-6">
						<label class="fuente-texto">Confirmar nueva contrase&ntilde;a</label>
						<input
							:class="{ 'is-invalid': $v.passNuevo2.$error }"
							class="form-control fuente-input"
							tabindex="3"
							type="password"
							v-model="$v.passNuevo2.$model"
						/>
					</div>
				</div>

				<div class="row">
					<div class="col-12 col-lg-5 offset-lg-1 mb-2">
						<router-link
							class="link btn btn-block fuente-boton-cancelar text-white"
							tabindex="4"
							to="/clientes/configuracion"
						>Cancelar</router-link>
					</div>
					<div class="col-12 col-lg-5">
						<button
							:disabled="error"
							@click="cambiarPassword"
							class="link btn btn-block fuente-boton-cambiar text-white"
							tabindex="5"
						>Cambiar contrase&ntilde;a</button>
					</div>
				</div>
			</div>
		</div>

		<b-modal @close="cerrarModal" 
					centered 
					id="modal-ok" 
					no-close-on-backdrop>
			<p class="fuente-texto1-modal text-center">¡Su contraseña ha sido cambiada con éxito!</p>
			<p
				class="fuente-texto2-modal text-center"
			>A partir de este momento ya puede ingresar con su nueva contraseña.</p>

			<div class="w-100">
				<div class="col-6 offset-3">
					<button
						@click="cerrarModal"
						class="link btn btn-block fuente-boton-continuar text-white"
					>Continuar</button>
				</div>
			</div>
		</b-modal>
	</div>
</template>


<script>
	import { required, minLength, sameAs } from "vuelidate/lib/validators"
	import servicio from "@/services/servicio-cuenta"
	export default {
		data() {
			return {
				passAnterior: "",
				passNuevo1: "",
				passNuevo2: "",
				mostrarModal: false
			}
		},
		components: {},
		mounted() {
			this.$refs.passAnterior.focus()
		},
		computed: {
			error() {
				return (
					this.passAnterior == "" ||
					this.passNuevo1 == "" ||
					this.passNuevo2 == "" ||
					this.$v.passAnterior.$error ||
					this.$v.passNuevo1.$error ||
					this.$v.passNuevo2.$error
				)
			}
		},
		validations: {
			passAnterior: {
				required
			},
			passNuevo1: {
				required,
				minLength: minLength(4)
			},
			passNuevo2: {
				sameAsPassword: sameAs("passNuevo1")
			}
		},
		methods: {
			cerrarModal() {
				this.$router.push("/clientes/configuracion")
			},
			cambiarPassword() {
				servicio
					.cambiarPassword(this.passAnterior, this.passNuevo1)
					.then(r => {
						if (r.value) {
							this.passAnterior = ""
							this.passNuevo1 = ""
							this.passNuevo2 = ""
							
							this.$bvModal.show("modal-ok")
						} else {
							this.$swal.fire({
								text: r.message,
								icon: "warning",
							})
							this.$refs.passAnterior.focus()
						}
					})
					.catch(e => {
						console.log(e)
					})
			}
		}
	}
</script>

<style scoped>
	.fondo-cambio {
		background-color: var(--color-blanco);
	}
	.fuente-titulo {
		font-family: "Open Sans";
		font-weight: bold;
		color: var(--bg-menu-blue);
	}
	.fuente-subtitulo {
		font-family: "Open Sans";
		font-weight: bold;
		color: var(--bg-menu-blue);
	}
	.fuente-texto {
		font-family: "Open Sans";
		color: var(--bg-menu-blue);
	}
	.fuente-boton-cancelar {
		background-color: #bcc1cf !important;
	}
	.fuente-boton-cancelar:hover {
		background-color: #707070 !important;
	}
	.fuente-boton-cambiar {
		background-color: var(--bg-menu-blue) !important;
	}
	.fuente-boton-cambiar:hover {
		background-color: var(--color-font-blue) !important;
	}
	.fuente-texto1-modal {
		font-family: "Open Sans";
		font-weight: 300;
		color: var(--bg-menu-blue);
	}
	.fuente-texto2-modal {
		font-family: "Open Sans";
		font-weight: 600;
		color: var(--bg-menu-blue);
	}
	.fuente-boton-continuar {
		background-color: #f1c240 !important;
	}
	.fuente-boton-continuar:hover {
		background-color: #ff8800 !important;
	}

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
		.fuente-titulo {
			font-size: 18px !important;
		}
		.fuente-subtitulo {
			font-size: 18px !important;
		}
		.fuente-texto {
			font-size: 16px !important;
		}
		.fuente-texto1-modal {
			font-size: 16px !important;
		}
		.fuente-texto2-modal {
			font-size: 16px !important;
		}
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		.fuente-titulo {
			font-size: 18px !important;
		}
		.fuente-subtitulo {
			font-size: 18px !important;
		}
		.fuente-texto {
			font-size: 16px !important;
		}
		.fuente-texto1-modal {
			font-size: 16px !important;
		}
		.fuente-texto2-modal {
			font-size: 16px !important;
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		.fuente-titulo {
			font-size: 18px !important;
		}
		.fuente-subtitulo {
			font-size: 18px !important;
		}
		.fuente-texto {
			font-size: 16px !important;
		}
		.fuente-texto1-modal {
			font-size: 16px !important;
		}
		.fuente-texto2-modal {
			font-size: 16px !important;
		}
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
		.fuente-titulo {
			font-size: 18px !important;
		}
		.fuente-subtitulo {
			font-size: 18px !important;
		}
		.fuente-texto {
			font-size: 16px !important;
		}
		.fuente-texto1-modal {
			font-size: 16px !important;
		}
		.fuente-texto2-modal {
			font-size: 16px !important;
		}
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
		.fuente-titulo {
			font-size: 18px !important;
		}
		.fuente-subtitulo {
			font-size: 18px !important;
		}
		.fuente-texto {
			font-size: 16px !important;
		}
		.fuente-texto1-modal {
			font-size: 16px !important;
		}
		.fuente-texto2-modal {
			font-size: 16px !important;
		}
	}
</style>